import React from 'react'
import Back from '../../Public/Image/Home/Back.svg'
import warning from '../../Public/Image/Home/warning.svg'
// import { LoaderCircle, Loader } from 'lucide-react';
import { useRef } from 'react';
import '../GetLinkUsername.css'
// import TextField from '@mui/material/TextField';
import CheckUsername from '../../BottomSheet/CheckUsername';
import ShowPriceAndChannel from '../../BottomSheet/ShowPriceAndChannel';
import { useState } from 'react';
// import { setBottomSheetCheckUsername } from '../../app/Home'
// import { setUserNameForOrder } from '../../app/Home'
import { GetCookie } from '../../Action/GetCookie';
// import { CheckChannelBeforePurchase } from './../Api/CheckChannelBeforePurchase'
// import { AllApi } from '../../Api/AllApi'
import Skeleton from '@mui/material/Skeleton';

import { useSelector, useDispatch } from 'react-redux'
import TooManyOrders from '../../BottomSheet/TooManyOrders'
import TooManyOrdersUser from '../../BottomSheet/TooManyOrdersUser'
// import { setBottomSheetTooManyOrdersUser } from '../../app/Home'
// import { setBottomSheetTooManyOrdersUserTitle } from '../../app/Home'
// import { setBottomSheetTooManyOrdersUserDescription } from '../../app/Home'

import ViolatingChannel from '../../BottomSheet/ViolatingChannel'
// import { setBottomSheetTooManyOrders } from '../../app/Home'
// import { setBottomSheetViolatingChannel } from '../../app/Home'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ShowPriceAndChannelCoin from '../../BottomSheet/ShowPriceAndChannelCoin'

// import { setMiniLoading } from '../../app/Home'
import { useHistory } from 'react-router-dom';
import useStore from '../../Zustand/AppSetting' // مسیر فایل zustand
// import Loading from './../../Loading'
// import {} from '../../Public/Image/Home/React'
// const importAll = (r) => r.keys().map(r);
// function importAll(r) {
//     return r.keys().map((key) => ({
//         src: r(key),
//         status: false, // or any logic for status
//     }));
// }
// let images = importAll(require.context('../../Public/Image/Home/React', false, /\.(png|jpe?g|svg)$/));

const SelectEmoji = () => {
    // const dispatch = useDispatch()
    const { market, data, loading, error, fetchData } = useStore()

    useEffect(() => {
        // console.log(1)
        fetchData('WebAppP')
    }, [])
    // console.log(data)
    // console.log(loading)
    // console.log(market)
    // const Email = useSelector((state) => state.counter.email)
    const MiniLoading = useSelector((state) => state.Home.MiniLoading)
    const Token = GetCookie('Token')
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);


    const history = useHistory();

    const Price = searchParams.get('Price');
    const Count = searchParams.get('Count');
    const _id = searchParams.get('_id');
    const sku = searchParams.get('sku');
    const ByCoin = searchParams.get('ByCoin');
    const HandleUsernameLink = async (SelectedEmoji) => {
        // console.log(SelectedEmoji)
        let emoji = emojiList.find(item => item.id == SelectedEmoji)
        // console.log(emoji)
        history.push(`/ReactionGetPostLink?Emoji=${emoji.emoji}&Price=${Price}&Count=${Count}&_id=${_id}&sku=${sku}&ByCoin=${ByCoin}`);
    }







    const [SelectedEmoji, setSelectedEmoji] = useState(null)
    const SetEmojiSelect = (index) => {
        setSelectedEmoji(index)

    };


    const [showAll, setShowAll] = useState(false);

    const emojiList = data?.data?.appSetting?.emojiList || [];

    const visibleEmojis = showAll ? emojiList : emojiList.slice(0, 16);



    const [validImages, setValidImages] = useState({});
    const checkImageURL = (url, timeout = 2000) => {
        return new Promise((resolve) => {
            const img = new Image();
            let timedOut = false;

            const timer = setTimeout(() => {
                timedOut = true;
                resolve(false);
            }, timeout);

            img.onload = () => {
                if (!timedOut) {
                    clearTimeout(timer);
                    resolve(true);
                }
            };
            img.onerror = () => {
                if (!timedOut) {
                    clearTimeout(timer);
                    resolve(false);
                }
            };
            img.src = url;
        });
    };
    const checkedRef = useRef({});
    useEffect(() => {
        const check = async () => {
            const newValidImages = {};

            for (let i = 0; i < visibleEmojis.length; i++) {
                if (checkedRef.current[i]) continue;
                const isValid = await checkImageURL(visibleEmojis[i].image || '');
                newValidImages[i] = isValid;
                setValidImages(prev => ({ ...prev, [i]: isValid })); // update progressively
                checkedRef.current[i] = true;
            }
        };

        check();
    }, [visibleEmojis]);
    // console.log(validImages[0])
    // console.log(Price)

    return (
        <div className='GetLinkReact'>
            <div className='GetLinkUsernameHeader'>
                <Link to="/Home?Status=React" className="GetLinkUsernameHeaderLink">
                    <img src={Back} className='GetLinkUsernameHeaderImg' />
                </Link>
                <div className='GetLinkUsernameHeaderText'>
                    Select Emoji
                </div>
            </div>
            <div className='GetLinkUsernameContent'>
                {/* {!showAll && */}
                <div className='GetLinkUsernameContentText1'>
                    Choose emojis for reactions on your
                    channel post
                </div>
                {/* } */}
                <div className='GetLinkUsernameInputContainer' >
                    <div className='EmojiContainer'>
                        {visibleEmojis.map((item, index) => (
                            <div
                                onClick={() => {
                                    if (validImages[index] !== undefined) {
                                        SetEmojiSelect(item.id);
                                    }
                                }}

                                // onClick={() =>  SetEmojiSelect(item.id)}
                                // className={`${SelectedEmoji === item.id ? "EmojiItemActive" : "EmojiItem"}`}
                                className={`
                ${SelectedEmoji === item.id ? "EmojiItemActive" : validImages[index] === undefined ? "EmojiItemBorderLess" : "EmojiItem"}
               
            `}
                                key={index}
                            >
                                {validImages[index] == false ?
                                    (
                                        item.emoji
                                    )
                                    :
                                    validImages[index] ?
                                        (
                                            <img
                                                width={24}
                                                height={24}
                                                src={item.image}
                                                alt={`Image ${index}`}
                                            />
                                        ) : (
                                            <Skeleton variant="rectangular" width={64} height={64} className='SkeletonEmoji' />
                                        )

                                }
                            </div>
                        ))}


                    </div>
                    <div className='ContainerMoreEmojiButton'>
                        {!showAll && emojiList.length > 5 && (
                            <button onClick={() => setShowAll(true)} className="MoreEmojiButton">
                                More Emoji
                            </button>
                        )}
                    </div>


                </div>

            </div>
            <div className='GetLinkReactionFooter'>
                {/* {!showAll && */}
                <div className='NoticeInSelectEmoji'>
                    <img src={warning} style={{ marginRight: '12px' }} />
                    <div className='NoticeInSelectEmojiText'>
                        Make sure reactions are turned on for your post
                    </div>
                </div>
                {/* } */}
                <button
                    className={SelectedEmoji != null
                        ? 'GetLinkUsernameFooterButton'
                        :
                        'GetLinkUsernameFooterButtonDisable'
                    }
                    onClick={() => HandleUsernameLink(SelectedEmoji)}
                    disabled={SelectedEmoji != null ? false : true}
                >
                    {/* {MiniLoading ? (
                        <div className='LoaderContainer'>
                            <div className="loadminijoin"></div>
                        </div>
                    ) : ( */}
                    Next
                    {/* // )} */}
                </button>
            </div>
            {
                ByCoin == 'true' ? <ShowPriceAndChannelCoin /> : <ShowPriceAndChannel />
            }
            <CheckUsername />

            <TooManyOrders />
            <TooManyOrdersUser />

            <ViolatingChannel />
        </div >
    )
}

export default SelectEmoji